import React from 'react';

import { Box, Menu } from '@mantine/core';
import { useSnapshot } from 'valtio';

import { ContextMenuService } from 'services/ContextMenuService';

import classes from './ContextMenu.module.scss';

const GlobalContextMenu = () => {
    const { x, y } = useSnapshot(ContextMenuService.state);

    return x !== null && y !== null ? (
        <Menu
            classNames={{
                dropdown: classes.dropdown,
                item: classes.item,
                itemSection: classes.itemSection,
            }}
            position="bottom-start"
            withinPortal={false}
            opened
            onClose={() => {
                ContextMenuService.close();
            }}
        >
            <Menu.Target>
                <Box
                    style={{
                        position: 'absolute',
                        left: x,
                        top: y,
                        zIndex: 9999,
                        width: 1,
                        height: 1,
                    }}
                ></Box>
            </Menu.Target>
            <Menu.Dropdown>{ContextMenuService.content}</Menu.Dropdown>
        </Menu>
    ) : null;
};

export { GlobalContextMenu };
